import React from 'react'
import { Alert } from 'antd'
import Slider from 'react-slick'
import { Notices as api } from '../../api/People/Notices'
import CustomSpin from '../../elements/CustomSpin'
import useFetchList from '../../elements/Hooks/useFetchList'

const settings = {
  speed: 500,
  autoplaySpeed: 5000,
}

function Notices (props) {
  const { list, fetching } = useFetchList(api.display)

  return (
    <CustomSpin spinning={fetching}>
      <Slider autoplay={true} {...settings} style={{ margin: '10px' }}>
        {list.map(notice => (
          <Alert
            showIcon
            style={{ margin: 10 }}
            message={notice.name}
            description={notice.description}
            type="info"
          />
        ))}
      </Slider>
    </CustomSpin>
  )
}

Notices.propTypes = {}
Notices.defaultProps = {}

export default Notices
